import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts'

const PRODUCT_COLORS = {
  PMS: '#3b82f6',
  AGO: '#f59e0b',
  LPG: '#22c55e',
  DPK: '#f97316',
}

function shortNaira(v) {
  if (v >= 1_000_000) return `₦${(v / 1_000_000).toFixed(1)}M`
  if (v >= 1_000) return `₦${(v / 1_000).toFixed(0)}k`
  return `₦${v}`
}

const tooltipStyle = {
  borderRadius: 8,
  border: 'none',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
  fontSize: 12,
}

function PctLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  if (percent < 0.05) return null
  const RADIAN = Math.PI / 180
  const r = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + r * Math.cos(-midAngle * RADIAN)
  const y = cy + r * Math.sin(-midAngle * RADIAN)
  return (
    <text
      x={x} y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={11}
      fontWeight="700"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

export default function FuelBreakdownChart({ data }) {
  if (!data.length) return null

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <p className="text-sm font-semibold text-gray-700 mb-3">Revenue by Fuel Type</p>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={data}
            dataKey="revenue"
            nameKey="product"
            cx="50%"
            cy="45%"
            outerRadius={80}
            innerRadius={40}
            labelLine={false}
            label={PctLabel}
          >
            {data.map((entry) => (
              <Cell
                key={entry.product}
                fill={PRODUCT_COLORS[entry.product] || '#6b7280'}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [shortNaira(value), name]}
            contentStyle={tooltipStyle}
          />
          <Legend
            wrapperStyle={{ fontSize: 12 }}
            iconType="circle"
            iconSize={8}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
